export const JSSLibraryView = theme => ({
    selectRoot: {

    }
});